<template>
  <div
    :class="[styles, value === option.value? 'is-active': null]"
    @click="$emit('input', option.value)"
  >
    <p>{{ option.label }}</p>
  </div>
</template>

<script>
export default {
  name: 'CircleQuestionnaireButton',
  props: {
    value: {
      type: [String, Boolean, Number],
      default: null,
    },
    option: {
      type: Object,
      required: true,
    },
    styles: {
      type: String,
      required: false,
      default: 'circle-questionnaire-button',
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.circle-questionnaire-button {
    color: $text-light-gray;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #e7eff8;

    font-size: var(--question-font-size);
    width: 4em;
    height: 4em;

    border-radius: 100%;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &.is-active {
        background: #0A6ECA;
         p {
            color: #fff;
        }
    }

    p {
        font-size: var(--question-font-size);
        color: #4b4b4b;
        margin: 0;
        padding: 0;
    }

    &:hover {
        background: #0A6ECA;
        p {
            color: #fff;
        }
    }
}
.custom-circle-questionnaire-button {
    color:#0A6ECA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
    @media (max-width: 768px) {
      margin: 10px;
    }
    background: #DBEDFE 0% 0% no-repeat padding-box;
    border: 1px solid #e7eff8;

    font-size: var(--question-font-size);
    width: 2em;
    height: 2em;

    border-radius: 100%;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &.is-active {
        background:#142B6F;
         p {
            color: #fff;
        }
    }

    p {
        font-size: var(--question-font-size);
        color: #0A6ECA;
        margin: 0;
        padding: 0;
    }

    &:hover {
        background:#142B6F;
        p {
            color: #fff;
        }
    }
}

.custom-circle-questionnaire-button-2 {
    color:#003570;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 4px;
    background:  #fff 0% 0% no-repeat padding-box;
    border: 1px solid #003570;

    font-weight: 400;
    font-size: xx-large;
    width: 0.75em;
    height: 0.75em;

    border-radius: 100%;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &.is-active {
        background:#142B6F;
         p {
            color: #fff;
        }
    }

    p {
      font-weight: 400;
    font-size: initial;
        color: #003570;
        margin: 0;
        padding: 0;
    }

    &:hover {
        background:#003570;
        p {
            color: #fff;
        }
    }
}

</style>
